jQuery(function($) {
    // run only on company page
    if (!$('.page-company').length) return;
    var disabled = false;
    function onResize() {
        var width = $(window).width();
        disabled = (width <= 768);
    }
    $(window).on('resize', _.throttle(onResize, 250));
    //$('.mist-about-us__team-member').hide();
    $('.mist-about-us__team-member').eq(0).addClass('tl').show();
    $('.mist-about-us__team-member').eq(1).addClass('tr').show();
    $('.mist-about-us__team-member').eq(2).addClass('bl').show();
    $('.mist-about-us__team-member').eq(3).addClass('br').show();
    // min and max inclusive
    function getRandom(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    var posClasses = ['tl', 'tr', 'bl', 'br'];
    function getNext() {
        var selection = $('.mist-about-us__team-member').not('.tl, .tr, .bl, .br, .md-selected');
        var len = selection.length;
        var index = getRandom(0,len-1);
        var el = selection.eq(index).addClass('md-selected');
        if (len <= 1) $('.mist-about-us__team-member').removeClass('md-selected');
        return el;
    }
    var lastPos = 0;
    var positions = [1,2,3];
    function getPosition() {
        var index = getRandom(0, positions.length-1);
        var pos = positions[index];
        // remove current pos
        positions.splice(index, 1);
        // add last pos
        positions.push(lastPos);
        lastPos = pos;
        return pos;
    }

    var intervalRef = setInterval(function(){
        if (disabled) return;
        var p = getPosition();
        var n = getNext();
        $('.mist-about-us__team-member.' + posClasses[p]).fadeOut('slow', function(){
            $(this).removeClass('tl tr bl br');
        });
        n.addClass(posClasses[p]).fadeIn('slow');
    }, 4000);
    if ('undefined' != typeof _site && _site.debug_backstop) disabled = true;
});
